module.exports = __webpack_public_path__ + "images/emoji/twisted_rightwards_arrows.c957e246c911c2737e37.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/twisted_rightwards_arrows.png
// module id = V0kp
// module chunks = 14